module.exports = __webpack_public_path__ + "static/img/red-poster.ae6d0578.jpg";